module.exports = __webpack_public_path__ + "static/media/discovery_pack_FR_128x128.b58bd334.png";